import { render } from "./ShortUpArrowIcon.vue?vue&type=template&id=5038f99c&scoped=true"
import script from "./ShortUpArrowIcon.vue?vue&type=script&lang=js"
export * from "./ShortUpArrowIcon.vue?vue&type=script&lang=js"

import "./ShortUpArrowIcon.vue?vue&type=style&index=0&id=5038f99c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5038f99c"

export default script